module.exports = __webpack_public_path__ + "media/images/character-img-service-intro-collab-abada77e8380a83d8823e034207ef07a.png";